import Pyramid from "./SVG/pyramid.svg?react";

const PyramidIcon = () => {
  return <Pyramid />;
};

export default PyramidIcon;
